import React, { useContext, useState, useEffect } from "react";
import { BubbleChat } from "flowise-embed-react";
import RalvieLogoUrl from "../assets/images/ralvie/ralvie-logo.svg";
import RalvieLogo from "../assets/images/ralvie_logo_without_name.svg";
import { sidebarContext } from "../util/context";

const App = () => {
  const { userProfile } = useContext(sidebarContext);
  const userphoto = userProfile?.profilePhoto;

  const [chatHeight, setChatHeight] = useState(window.innerHeight * 0.8);

  useEffect(() => {
    const handleResize = () => {
      setChatHeight(window.innerHeight * 0.8);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <BubbleChat
        chatflowid="f6ab99a2-f975-4720-b484-8017d4ad0914"
        apiHost="https://flowiseai.minervaiotstaging.com"
        chatflowConfig={{}}
        observersConfig={{}}
        theme={{
          button: {
            backgroundColor: "#1d0b77",
            right: 20,
            bottom: 20,
            size: 48,
            dragAndDrop: true,
            iconColor: "white",
            customIconSrc:
              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKpEKqEsuvFzC4MHBMOawJZlFKEI4xG7wf4DL7PW4sA9xvse9BnodgSqB41wbAiyzNOYw&usqp=CAU",
            autoWindowOpen: {
              autoOpen: false,
              openDelay: 2,
              autoOpenOnMobile: false,
            },
          },
          customCSS: ``,
          chatWindow: {
            showTitle: true,
            showAgentMessages: true,
            title: "Ralvie Bot",
            titleAvatarSrc: RalvieLogo,
            welcomeMessage: `Hi there! Ralvie Bot supports:<ul>
                                         <li>English</li>
                                         <li>汉语 (Chinese)</li>
                                         <li>한국인 (Korean)</li>
                                         <li>Español (Spanish)</li>
                                         <li>日本語 (Japanese)</li>
                                       </ul>
                                       You can start the conversation in your preferred language.`,

            errorMessage: "This is a custom error message",
            backgroundColor: "#ffffff",
            backgroundImage: "",
            height: chatHeight,
            width: 400,
            fontSize: 16,
            starterPrompts: [],
            starterPromptFontSize: 15,
            clearChatOnReload: false,
            sourceDocsTitle: "Sources:",
            renderHTML: true,
            botMessage: {
              backgroundColor: "#f7f8ff",
              textColor: "#303235",
              showAvatar: true,
              avatarSrc: RalvieLogo,
            },
            userMessage: {
              backgroundColor: "#1d0b77",
              textColor: "#ffffff",
              showAvatar: true,
              avatarSrc:
                userphoto ||
                "https://raw.githubusercontent.com/zahidkhawaja/langchain-chat-nextjs/main/public/usericon.png",
            },
            textInput: {
              placeholder: "Type your question",
              backgroundColor: "#ffffff",
              textColor: "#303235",
              sendButtonColor: "#1d0b77",
              maxChars: 50,
              maxCharsWarningMessage:
                "You exceeded the characters limit. Please input less than 50 characters.",
              autoFocus: true,
              sendMessageSound: true,
              sendSoundLocation: "send_message.mp3",
              receiveMessageSound: true,
              receiveSoundLocation: "receive_message.mp3",
            },
            feedback: {
              color: "#303235",
            },
            dateTimeToggle: {
              date: true,
              time: true,
            },
            footer: {
              textColor: "#303235",
              text: "Powered by",
              company: "Ralvie AI",
              companyLink: "https://me.ralvie.ai",
            },
          },
        }}
      />
    </>
  );
};

export default App;
